import {Company} from "./company.model";

export class Site {

  public id?: number;
  public name?: string;
  public country?: string;
  public postalCode?: number;
  public city?: string;
  public address?: string;
  public fulladdress?: string;
  public company?: Company;
  public networks?: number;


  constructor (data?: any) {
    if (data) {
      this.id = data.id;
      this.name = data.name;
      this.country = data.country;
      this.postalCode = data.postalCode;
      this.city = data.city;
      this.address = data.address;
      this.networks = data.networks;
      this.fulladdress = data.fulladdress;
      if (data.company) {
        this.company = new Company(data.company);
      }
    }
    if (!this.country) {
      this.country = "Magyarország";
    }
  }

  fullAddress() {
    return `${this.postalCode} ${this.city} ${this.address}`;
  }

}
